import { RecommendationAction } from '@/experiences/sales-portal/domain/pricing-agent/blocs/stores/recommendation-actions-store-types';

/**
 * A row's displayed status: the user's local edit where there is one, otherwise
 * the backend status. On auto-accepted screens a row with no backend status is
 * accepted by default — there is no pending state there.
 */
export const resolveEffectiveAction = (
  localAction: RecommendationAction | undefined,
  reviewStatus: RecommendationAction | null | undefined,
  defaultAccepted: boolean,
): RecommendationAction | null =>
  localAction ??
  reviewStatus ??
  (defaultAccepted ? RecommendationAction.Accepted : null);
